import React from 'react';
import { BdsIcon, BdsTableBody, BdsTableHeader, BdsTableRow, BdsTableTh, BdsTooltip, BdsTypo } from 'blip-ds/dist/blip-ds-react';
import { Table } from '../styles';
import { BdsCheckboxCustomEvent } from 'blip-ds/loader';
import { WhatsAppApplication } from '../typing/models/whatsapp-application.interface';
import ListItem from '../ListItem';

interface ListBotCallsProps {
  bots: WhatsAppApplication[];
  translate: Record<string, any>;
  onEnableCalling: (application: WhatsAppApplication, enabled: boolean) => Promise<boolean>;
  onEnableIconVisibility: (application: WhatsAppApplication, enabled: boolean) => Promise<boolean>;
  onEnableCallbackPermission: (application: WhatsAppApplication, enabled: boolean) => Promise<boolean>;
  onChangeSelectBot: (event: BdsCheckboxCustomEvent<any>) => void;
  onOpenModalStatus: (ownerIdentity: string) => void;
}

const ListBotCalls: React.FC<ListBotCallsProps> = ({
  bots,
  translate,
  onEnableCalling,
  onEnableIconVisibility,
  onEnableCallbackPermission,
  onChangeSelectBot,
  onOpenModalStatus,
}) => {
  return bots?.length ? (
    <Table>
      <BdsTableHeader>
        <BdsTableRow>
          <BdsTableTh className="checkbox-th" />
          <BdsTableTh>{translate.list.title}</BdsTableTh>
          <BdsTableTh>Id</BdsTableTh>
          <BdsTableTh>
            <div className='flex'>
              <BdsTypo variant="fs-14" className='mr2'>{translate.list.callbackPermission.title}</BdsTypo>
              <BdsTooltip position="bottom-right" tooltip-text={translate.list.callbackPermission.tooltip}>
                <BdsIcon size="small" name="info"/>
              </BdsTooltip>
            </div>
          </BdsTableTh>
          <BdsTableTh>{translate.list.action}</BdsTableTh>
          <BdsTableTh className="status-th">Status</BdsTableTh>
        </BdsTableRow>
      </BdsTableHeader>
      <BdsTableBody>
        {bots.map((bot, idx) => {
          return (
            <ListItem
              key={`${idx}-${bot.id}`}
              bot={bot}
              translate={translate.detailsBots}
              onEnableCalling={onEnableCalling}
              onEnableIconVisibility={onEnableIconVisibility}
              onEnableCallbackPermission={onEnableCallbackPermission}
              onChangeSelectBot={onChangeSelectBot}
              onOpenModalStatus={onOpenModalStatus}
            />
          );
        })}
      </BdsTableBody>
    </Table>
  ) : (
    <></>
  );
};

ListBotCalls.displayName = 'ListBotCalls';

export default ListBotCalls;
